import React from 'react'
import './assets/styles/main.css'
import {unstable_HistoryRouter as HistoryRouter} from 'react-router-dom'
import Providers from './providers/providers'
import RenderRoutes from './components/RenderRoutes'
import RHelmet from './components/RHelmet'
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import ScrollToTop from './components/ScrollToTop'
import ModalLayout from './components/modals/ModalLayout'
import Backdrop from './components/layout/Backdrop'
import {createBrowserHistory} from 'history'

export const history = createBrowserHistory()

const App = () => {
  return (
    <HistoryRouter history={history}>
      <Providers>
        <RHelmet />
        <Header />
        <main className={`content`}>
          <RenderRoutes />
        </main>
        <Footer />
        <ModalLayout />
        <Backdrop />
        <ScrollToTop />
      </Providers>
    </HistoryRouter>
  )
}

export default App
